import { Component, Output, EventEmitter, Input } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { FeedbackService } from '../feedback.service';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { StorageHelper } from '../helpers/StorageHelper';

@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.scss'],
  providers: [ FeedbackService ]
})
export class FeedbackFormComponent extends BaseComponent {

  rating: number;
  feedbackText: string = "";
  name: string = "";
  email: string = "";
  sentWithSuccess: boolean;
  invalidEmail: boolean = false;
  emptyFields: boolean = false;
  @Input() textStringKey: string = ""; //default text for feedback is nothing. Overwrite if wanted
  @Output() onDone = new EventEmitter();

  constructor(private feedbackService: FeedbackService) {
    super();
    this.reinit();
  }

  reinit() {
    this.sentWithSuccess = false;
    this.rating = 0;
    this.feedbackText = "";
  }

  sendClicked() {

    let ratingString = this.rating != 0 ? this.rating + "/5" : "";

    let text = this.feedbackText + "\n" + ratingString + "\n" + location;

    const email = this.getEmailForSubmission();

    if (email !== "" && !ValidationHelper.isValidEmail(email)) {
      this.invalidEmail = true;
      return;
    }

    if(this.feedbackText == "") {
      this.emptyFields = true;
      return;
    }

    this.feedbackService.send(this.name, email, text).subscribe(res => {

      this.sentWithSuccess = true;

    },err=> {
      this.reinit();
      this.onDone.emit();
    });

  }

  starClick(index:number) {
    this.rating = index;
  }

  textUpdated(e) {
    this.feedbackText = e.target.value;
  }

  emailUpdated(e) {
    this.email = e.target.value;
    this.invalidEmail = false;
    this.emptyFields = false;
  }

  nameUpdated(e) {
    this.name = e.target.value;
    this.emptyFields = false;
  }

  private getEmailForSubmission(): string {
    if (this.email !== "") {
      return this.email;
    }
    return this.getLoggedInEmail();
  }

  private getLoggedInEmail(): string {
    const storageHelper = StorageHelper.getInstance();
    const sessionToken = storageHelper.get(StorageHelper.keys.sessionToken);
    const email = storageHelper.get(StorageHelper.keys.email);

    if (sessionToken && email) {
      return email;
    }

    return "";
  }

}
